import { render, staticRenderFns } from "./empty-cart-button.vue?vue&type=template&id=4b71e6cc&"
import script from "./empty-cart-button.vue?vue&type=script&lang=js&"
export * from "./empty-cart-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports